import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";

import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import API from "../../services/api";
import { format } from "date-fns";
import {
  capitalizeFirstLetter,
  rejectMessOptions,
} from "../../utils/constants";
import { formatDateWithTime } from "../../utils/dateFormat";
import PdfViewer from "../Orders/PdfViewer";
function SlotHistory(props) {
  const [data, setData] = useState([]);
  const [dateHeaders, setDateHeaders] = useState([]);
  const [loader, setLoader] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");

  const fetchRecentyActivity = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/slotbooking/get-slot-history",
        method: "POST",
        responseType: "json",
        data: {
          slot_id: props.slotLog_id,
        },
      });
      if (res.code === 200) {
        setData(res.data.logs);
        setDateHeaders(res.data.dateHeaders);
        setInitialRender(false);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchRecentyActivity();
  }, []);
  useEffect(() => {
    if (props.slotLog_id && !initialRender) fetchRecentyActivity();
  }, [props.slotLog_id]);
  // useEffect(() => {
  //   setEditItem(null);
  //   if (!initialRender) {
  //     fetchRecentyActivity();
  //   }
  // }, [bookSlotModalOpen]);
  // const editAction = (item) => {
  //   try {
  //     setEditItem({ ...item, action: "edit" });
  //     setBookSlotModalOpen(true);
  //   } catch (error) {
  //     console.error("Error @ editAction", error);
  //   }
  // };

  return (
    <SlDrawer
      open={props.slotLog_id ? true : false}
      onSlAfterHide={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.setSlotLog_id(null);
      }}
      onSlRequestClose={(event) => {
        if (event.detail.source === "overlay") {
          event.preventDefault();
          props.setSlotLog_id(null);
        }
      }}
      label={`Order Updates History ${capitalizeFirstLetter(data[0]?.slot_name || '')}`}
      style={{ "--size": "1000px" }}
      className={styles["sldrawer-container"]}
    >
      <div className={`${styles["slot-history"]}`} id={styles["activityPanel"]}>
        {/* Activity Cards Wrapper */}
        <div className={styles["activity-cards"]}>
          {dateHeaders?.length && !loader ? (
            dateHeaders.map((dateStamp) => {
              let startDate = dateStamp;
              let endDate = new Date(dateStamp * 1000);
              endDate.setHours(23, 59, 59, 59);
              endDate = Math.floor(endDate.getTime() / 1000);
              let logs = data.filter(
                (item) => startDate <= item.time && item.time <= endDate
              );
              return (
                <div className={styles["dayPosCard"]}>
                  <div className={styles["day"]}>
                    <h6>{format(new Date(dateStamp * 1000), "EEE")}</h6>
                    <h1>{format(new Date(dateStamp * 1000), "d")}</h1>
                  </div>
                  <div className={styles["card-wrapper"]}>
                    <div className="overflow-x-auto">
                      {/* <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Slot Name</th>
                            <th>User</th>
                            <th>Type</th>
                            <th>Previous</th>
                            <th>Updated</th>
                            <th>Time</th>
                          </tr>
                        </thead>

                        <tbody>
                          {logs?.map((logItem) => {
                            return logItem?.update.map((log, index) => {
                              if (log.type === "Date Ranges") {
                                log.previous = (
                                  <span className="d-flex flex-col">
                                    {log.previous.map((item) => (
                                      <span>
                                        {item.start_date}-{item.end_date}
                                      </span>
                                    ))}
                                  </span>
                                );
                                log.updated = (
                                  <span className="d-flex flex-col">
                                    {log.updated.map((item) => (
                                      <span>
                                        {item.start_date}-{item.end_date}
                                      </span>
                                    ))}
                                  </span>
                                );
                              } else if (log.type === "End Date") {
                                log.previous = formatDateWithTime(log.previous);
                                log.updated = formatDateWithTime(log.updated);
                              }
                              return (
                                <tr key={index}>
                                  <td>{logItem.slot_name}</td>
                                  <td>{logItem.user_name}</td>
                                  <td>{log.type}</td>
                                  <td>{log.previous || "-"}</td>
                                  <td>{log.updated || "-"}</td>
                                  <td>{formatDateWithTime(logItem.time)}</td>
                                </tr>
                              );
                            });
                          })}
                        </tbody>
                      </table> */}
                      <table className="table table-bordered compLogs">
                        <thead>
                          <tr>
                            <th className="row-span-2">Order Name</th>
                            <th className="row-span-2">Internal Id</th>
                            {/* <th  className="row-span-2">User Type</th>
                                <th className="row-span-2">User</th>
                                <th  className="row-span-2">Time</th> */}
                            <th className="splThead">
                              <table>
                                <tr>
                                  <th colspan="3">Details</th>
                                </tr>
                                <tr>
                                  <th>Type</th>
                                  <th>Previous</th>
                                  <th>Updated</th>
                                </tr>
                              </table>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {logs?.map((logItem) => {
                            return (
                              <tr
                                className={`row-span-${logItem.update.length}`}
                              >
                                <td>
                                  {capitalizeFirstLetter(logItem.user_name)}
                                  {`(`}
                                  {logItem.user_type}
                                  {")"}
                                  <br />
                                  {formatDateWithTime(logItem.time)}
                                </td>
                                <td>{logItem.internal_id || 'Whole'}</td>
                                {/* <td>{capitalizeFirstLetter(logItem.user_name)}</td>
                                        <td>{logItem.user_type}</td>
                                        <td>{formatDateWithTime(logItem.time)}</td> */}
                                <td colspan="3" className="splTdata">
                                  <table>
                                    {logItem.update.map((upItem) => {
                                      let currentLog = { type: upItem.type };
                                      if (upItem.type === "Date Ranges") {
                                        currentLog.previous = (
                                          <span className="d-flex flex-col">
                                            {upItem.previous.map((item) => (
                                              <span>
                                                {item.start_date}-
                                                {item.end_date}
                                              </span>
                                            ))}
                                          </span>
                                        );
                                        currentLog.updated = (
                                          <span className="d-flex flex-col">
                                            {upItem.updated.map((item) => (
                                              <span>
                                                {item.start_date}-
                                                {item.end_date}
                                              </span>
                                            ))}
                                          </span>
                                        );
                                      } else if (
                                        upItem.type ===
                                          "Approved Reason File" ||
                                        upItem.type === "PDC File" ||
                                        upItem.type === "Ro File" ||
                                        upItem.type === "Non Billing Reason"
                                      ) {
                                        currentLog.previous =
                                          upItem.previous ? (
                                            <div>
                                              <sl-icon-button
                                                title={upItem.previous}
                                                library="lucide"
                                                name="view"
                                                onClick={() => {
                                                  setPdfUrl(upItem.previous);
                                                }}
                                              ></sl-icon-button>
                                            </div>
                                          ) : (
                                            "-"
                                          );
                                        currentLog.updated = upItem.updated ? (
                                          <div>
                                            <sl-icon-button
                                              title={upItem.updated}
                                              library="lucide"
                                              name="view"
                                              onClick={() => {
                                                setPdfUrl(upItem.updated);
                                              }}
                                            ></sl-icon-button>
                                          </div>
                                        ) : (
                                          "-"
                                        );
                                      } else if (
                                        upItem.type === "status" &&
                                        upItem.updated === "Rejected"
                                      ) {
                                        currentLog.updated = (
                                          <div>
                                            <b>{upItem.updated}</b> <br />{" "}
                                            Description: {upItem.description}{" "}
                                            <br /> Reasons:{" "}
                                            {upItem.reason
                                              .map(
                                                (index) =>
                                                  rejectMessOptions[index]
                                              )
                                              .join(", ")}
                                          </div>
                                        );
                                      } else if (upItem.type === "status") {
                                        currentLog.previous = (
                                          <b>{upItem.previous || "-"}</b>
                                        );
                                        currentLog.updated = (
                                          <b>{upItem.updated || "-"}</b>
                                        );
                                      } else {
                                        currentLog.previous = upItem.previous;
                                        currentLog.updated = upItem.updated;
                                      }

                                      return (
                                        <tr>
                                          <td>{currentLog.type}</td>
                                          <td>{currentLog.previous || "-"}</td>
                                          <td>{currentLog.updated || "-"}</td>
                                        </tr>
                                      );
                                    })}
                                  </table>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              );
            })
          ) : !dateHeaders?.length && !loader ? (
            <div className="w-full h-full d-flex justify-center">
              <NoDataFound colspan="15" />
            </div>
          ) : (
            <div className="w-full h-full d-flex justify-center">
              <TableLoader colspan="15" />
            </div>
          )}
        </div>
        {/* Book Slot Modal Content */}
        {/* {bookSlotModalOpen && (
        <BookSlot
          show={bookSlotModalOpen}
          setShow={setBookSlotModalOpen}
          editItem={editItem}
        />
      )} */}
        {/* Book Slot Modal Content */}
      </div>
      {pdfUrl ? (
        <PdfViewer
          url={pdfUrl}
          show={pdfUrl}
          setShow={setPdfUrl}
          placement={"start"}
        />
      ) : null}
    </SlDrawer>
  );
}

export default SlotHistory;
